up.compiler(".up_copy_tooltip", function (element) {
  const button = element.querySelector("button");
  const copied = element.querySelector(".js-copied");

  function onClick() {
    navigator.clipboard.writeText(element.dataset.tobecopied).then(() => {
      copied.classList.remove("hidden");
      setTimeout(() => copied.classList.add("hidden"), 1000);
    });
  }
  button.addEventListener("click", onClick);
  return () => {
    button.removeEventListener("click", onClick);
  };
});
